import { useState, useEffect } from 'react';

// Hook to manage button links from admin panel
export const useButtonLinks = () => {
  const [buttonLinks, setButtonLinks] = useState({
    getStarted: 'https://ma.riverprime.my/registration',
    tryDemo: 'https://ma.riverprime.my/registration',
    login: 'https://ma.riverprime.my/login',
    learnMore: '/about',
    contactUs: '#contact',
    downloadMT5: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt5/mt5setup.exe',
    openAccount: 'https://ma.riverprime.my/registration',
    viewPricing: '/pricing',
    becomePartner: 'https://ma.riverprime.my/registration',
    readMore: '/learn',
    createAccount: 'https://ma.riverprime.my/registration',
    register: 'https://ma.riverprime.my/registration',
    signUp: 'https://ma.riverprime.my/registration',
    createDemo: 'https://ma.riverprime.my/registration',
    demoAccount: 'https://ma.riverprime.my/registration'
  });

  useEffect(() => {
    const loadButtonLinks = () => {
      const savedLinks = localStorage.getItem('adminButtonLinks');
      if (savedLinks) {
        try {
          const parsedLinks = JSON.parse(savedLinks);
          setButtonLinks(prev => ({
            ...prev,
            ...parsedLinks
          }));
        } catch (error) {
          console.error('Error loading button links:', error);
        }
      }
    };

    loadButtonLinks();

    // Listen for button link updates from admin panel
    const handleButtonLinksUpdate = (event) => {
      if (event.detail) {
        setButtonLinks(prev => ({
          ...prev,
          ...event.detail
        }));
      }
    };

    window.addEventListener('buttonLinksUpdated', handleButtonLinksUpdate);
    
    return () => {
      window.removeEventListener('buttonLinksUpdated', handleButtonLinksUpdate);
    };
  }, []);

  // Helper function to get a specific button link
  const getButtonLink = (buttonKey) => {
    return buttonLinks[buttonKey] || '#';
  };

  // Helper function to handle button click with proper navigation
  const handleButtonClick = (buttonKey, event) => {
    event?.preventDefault();
    const url = getButtonLink(buttonKey);
    
    if (url === '#' || !url) {
      console.warn(`No URL set for button: ${buttonKey}`);
      return;
    }

    // Handle different types of URLs
    if (url.startsWith('mailto:')) {
      // Email links
      window.location.href = url;
    } else if (url.startsWith('http://') || url.startsWith('https://')) {
      // External links - open in new tab
      window.open(url, '_blank', 'noopener,noreferrer');
    } else if (url.startsWith('#')) {
      // Anchor links - smooth scroll
      const element = document.querySelector(url);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Internal navigation - use client-side routing
      window.location.href = url;
    }
  };

  return {
    buttonLinks,
    getButtonLink,
    handleButtonClick
  };
};

export default useButtonLinks;